import { render, staticRenderFns } from "./toPay.vue?vue&type=template&id=6cf104b0&"
import script from "./toPay.vue?vue&type=script&lang=js&"
export * from "./toPay.vue?vue&type=script&lang=js&"
import style0 from "./toPay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports